import HelpCategoryPage from '../../src/pages/HelpCategoryPage';

export default HelpCategoryPage;
